import { Airport } from '@flyblack/common/domains';

import { authorizedApi } from '@/services/network/authorized-api';

export const getAirports: () => Promise<Airport[]> = () => authorizedApi.get(`/v1/airports`);
